






























































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import SingleText from '@/components/common/elements/SingleText.vue';
import Typography from '@/components/common/elements/Typography.vue';
import InputNoVModel from '@/components/common/elements/InputNoVModel.vue';
import SelectNoVModel from '@/components/common/elements/SelectNoVModel.vue';
import Table from '@/components/common/elements/Table.vue';
import { SelectProps } from '@/constants/form/types';
import BaseModel from '@/models/baseModel';
import { ItemActions } from '@/services/hexabase/types';
import hexabaseState from '@/store/hexabase';
import ConstructionModel from '@/models/constructionModel';
import Dialog from '@/components/common/modules/Dialog.vue';

@Component({
  components: { SingleText, Typography, Table, InputNoVModel, SelectNoVModel, Dialog }
})
export default class DialogFormDownload extends Vue {
  // ダイアログ開閉状態
  @Prop({ default: false })
  private dialog?: boolean;
  // ダイアログのエリア外を押下した際にBOXを閉じるか
  @Prop({ default: true })
  private isPersistent?: boolean;
  // セレクトの操作
  @Prop({ default: false })
  private isSelectDisabled?: boolean;
  // 出力帳票選択で表示するセレクト用配列
  private formItem: SelectProps = { name: '', options: [] };
  // 選択されている出力帳票項目
  private selectFormItem: any = { value: '', text: '' };
  // baseModelの読み込み
  private baseModel = new BaseModel();
  // 帳票ダウンロード対象のアイテムデータ
  @Prop({ default: '' })
  private downloadItemId: any;
  // 工事ドメインモデル
  private constructionModel = new ConstructionModel();
  // アイテムのアクション
  private itemActions: Array<ItemActions> = [];
  // 工事データストアID
  private mainDsId = hexabaseState.datastoreIds['工事'];
  // エラーメッセージ用
  private selectErrorMessages = '';
  /** APIに問い合わせ中に表示する「loading」フラグ */
  private isLoading = false;

  // アラートダイアログの表示制御値
  private alertDialogStatus = false;
  // ダイアログ内表示タイトル
  private alertDialogTitle = '';
  // ダイアログ内表示テキスト
  private alertDialogBodyText = '';

  /**
   * 初期値の設定
   */
  mounted() {
    // TODO:帳票マスタからデータを取得

    // 選択肢リストをセット(valueに該当アクションのaction_nameをセット)
    this.formItem = { name: 'form_type', options: [
      {value: '工事原価台帳出力', text: '工事原価台帳'}
    ] };

    // // 小項目のセレクトボックスデータ取得
    // this.formItem = this.baseModel.setSelectItemArrayFormat(
    //   this.body,
    //   this.searchFormItemData.findItemName,
    //   this.searchFormItemData.setItemValue,
    //   this.searchFormItemData.setItemText
    // );
  }

  /**
   * ダイヤログ内の初期化を行う、親コンポーネントに押下したか否か通知する
   * @module confirmOperation
   * @return {AddDetailResponse} - 要素ステータス、押下判定
   */
  @Emit('confirmOperation')
  public confirmOperation(isAgree: boolean): { [k: string]: boolean } {
    return { dialog: false, isAgree: isAgree };
  }

  /**
   * 帳票のダウンロードを行う、親コンポーネントに押下したか否か通知する
   * @module downloadButtonOperation
   * @return {void}
   */
  @Emit('downloadButtonOperation')
  public downloadButtonOperation(): void {
    this.downloadFile(this.downloadItemId);
  }

  /**
   * 出力帳票セレクトボタンで選択した際に選択内容を更新する。
   * @module changeSelectFormItemOperation
   * @param {Object} data - 子コンポーネントより渡される値
   */
  public changeSelectFormItemOperation(data: { [k: string]: string }) {
    this.selectFormItem = data;
    
    if(this.selectFormItem.value !== ''){
      // エラーメッセージクリア
      this.selectErrorMessages = '';
    }
  }

  /**
   * 該当のアクションをたたいて帳票をダウンロードする
   * @module downloadFile
   * @param {Object} item - アイテム情報
   */
  private async downloadFile(itemId: any) {
    this.selectErrorMessages = '';

    // 帳票未選択時はエラー
    if(!this.selectFormItem.value){
      // エラーメッセージ表示
      this.selectErrorMessages = '選択してください';
      
      return false;
    }

    this.isLoading = true;

    // 帳票セレクトボックスのvalueから叩くアクション名を取得
    const actionName = this.selectFormItem.value;

    // 既存アイテムを取得しアイテム情報・アクション情報を保持
    const constructionBasicResult = await this.constructionModel.getLinkedItems(
      hexabaseState.applicationId,
      this.mainDsId,
      itemId
    );

    constructionBasicResult.item_actions.forEach(v => this.itemActions.push(v));

    const fileAction = this.itemActions.find(function(v) {
      if (v.action_name === actionName) {
        return v;
      }
    });

    if (fileAction) {
      try {
        // 日付形式のデータを和暦に変換してアクションスクリプト内に渡す
        const dates = constructionBasicResult.field_values.map((item: any) => {
          if (item.dataType === 'datetime') {
            const wareki = this.dateDisplayTypeChange(item.value);
            const date: any = {};
            date[item.field_id] = wareki;
            return date;
          }
        }).filter(Boolean);

        const params: any = {};
        for (let i = 0; i < dates.length; i++) {
          const key: any = Object.keys(dates[i]);
          params[key[0]] = dates[i][key[0]]
        }
        // 帳票出力用のアクションを実行(帳票ファイルデータを生成し、Hexabaseへ保存し、ファイルIDなどをreturn)
        const fileActionResponse = await this.constructionModel.executeAction(
          hexabaseState.applicationId,
          this.mainDsId,
          itemId,
          fileAction.display_id,
          {
            "return_item_result": true,
            "is_force_update": true,
            "as_params": params
          }
        );

        // アクションスクリプトが想定通り終了したかをチェック(アクションスクリプト未定義などを防ぐ目的。reject()でreturnされたらfileActionResponse.data.detailsに入るはず)
        if (!fileActionResponse.data.details) {
          console.log("error : No fileActionResponse.data.details");
          this.isLoading = false;
          this.openAlertDialog();
          return false;
        }

        // ファイルダウンロード
        const fileActionResult = fileActionResponse.data.details.result;
        if (fileActionResult.status === 200) {
          const res = this.constructionModel.getXlxsFileDownload(
            fileActionResult.file_id,
            fileActionResult.file_name
          );
        } else {
          // 帳票出力エラー時
          console.log("error : File download NG", fileActionResult);
          this.openAlertDialog();
        }
      } catch (error) {
        console.error(error);
        this.openAlertDialog();
      }
    }
    this.isLoading = false;
  }

  /**
   * 子コンポーネントから受け取る、アラートダイアログで押下したボタンを受け取る
   * @module alertDialogConfirmOpratipon
   * @param {boolean} isOK - 子コンポーネントで押下したボタンタイプ(true：OK、false：キャンセル)
   */
  private alertDialogConfirmOpratipon(isOK: boolean) {
    this.closeAlertDialog();
  }

  /**
   * アラートダイアログを表示
   * @module openAlertDialog
   * @param {void}
   */
  private openAlertDialog() {
    // エラー時
    this.alertDialogTitle = 'エラー';
    this.alertDialogBodyText = '帳票ダウンロードに失敗しました。';

    this.alertDialogStatus = true;
  }

  /**
   * アラートダイアログを非表示
   * @module closeAlertDialog
   * @param {void}
   */
  private closeAlertDialog() {
    this.alertDialogStatus = false;

    this.alertDialogTitle = '';
    this.alertDialogBodyText = '';
  }

  /**
   * 日付の形式変換
   * @module catchInputBasic
   * @param  value - 子コンポーネントより渡される値
   * @param  displayType - 表示用のパラメータ(例：monthlyの場合、年月)
   * @return dateString - 形式変換した日付
   */
  private dateDisplayTypeChange(value: any) {
    if (value === null) {
      return '';
    } else {
      const date = new Date(value);
      const warekiDateString: any = {};

      const warekiFormattedDate = date.toLocaleDateString('ja-JP-u-ca-japanese');
      const [wareki, month, day] = warekiFormattedDate.split('/');
      const warekiNumber = wareki.slice(1);
      warekiDateString['wareki'] = Number(warekiNumber);
      warekiDateString['month'] = Number(month);
      warekiDateString['day'] = Number(day);

      return warekiDateString;
    }
  }

}
